import styled from "styled-components";

export const Logo = styled.div`
  background-color: ${props => props.theme.colors[0]};
  display: flex;
  height: 75px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 5px 0 ${props => props.theme.colors[13]};
  width: 100%;

  img {
    max-width: 256px;
    padding: 0 5px;
  }

  @media (max-width: 1024px) {
    box-shadow: none;
    height: auto;
  }
`;
